module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-form"
  }, [_c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-part"
    }
  }, [_vm._v("상담분야(택1)")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselFieldContribute"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.field),
      expression: "application.field"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselPart",
      "id": "counselFieldContribute",
      "value": "사회공헌",
      "title": "사회공헌 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.field, "사회공헌")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "field", "사회공헌")
      }
    }
  }), _vm._v(" 사회공헌\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselFieldRelation"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.field),
      expression: "application.field"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselPart",
      "id": "counselFieldRelation",
      "value": "사회적관계",
      "title": "사회적관계 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.field, "사회적관계")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "field", "사회적관계")
      }
    }
  }), _vm._v(" 사회적관계\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselFielddWork"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.field),
      expression: "application.field"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselPart",
      "id": "counselFieldWork",
      "value": "일",
      "title": "일 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.field, "일")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "field", "일")
      }
    }
  }), _vm._v(" 일\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselFieldFinance"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.field),
      expression: "application.field"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselPart",
      "id": "counselFieldFinance",
      "value": "재무",
      "title": "재무 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.field, "재무")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "field", "재무")
      }
    }
  }), _vm._v(" 재무\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselFieldFamily"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.field),
      expression: "application.field"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselPart",
      "id": "counselFieldFamily",
      "value": "가족",
      "title": "가족 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.field, "가족")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "field", "가족")
      }
    }
  }), _vm._v(" 가족\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselFieldLeisure"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.field),
      expression: "application.field"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselPart",
      "id": "isLeisure",
      "value": "여가",
      "title": "여가 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.field, "여가")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "field", "여가")
      }
    }
  }), _vm._v(" 여가\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselFieldHealth"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.field),
      expression: "application.field"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselPart",
      "id": "counselFieldHealth",
      "value": "건강",
      "title": "건강 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.field, "건강")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "field", "건강")
      }
    }
  }), _vm._v(" 건강\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking-2",
    attrs: {
      "for": "counselFieldEtc"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.field),
      expression: "application.field"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselPart",
      "id": "counselFieldEtc",
      "value": "기타",
      "title": "기타 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.field, "기타")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "field", "기타")
      }
    }
  }), _vm._v(" 기타\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.fieldEtc),
      expression: "application.fieldEtc"
    }],
    attrs: {
      "type": "text",
      "placeholder": "기타",
      "disabled": _vm.application.field !== '기타',
      "name": "etcContext",
      "class": "",
      "title": "기타"
    },
    domProps: {
      "value": (_vm.application.fieldEtc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application, "fieldEtc", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix agree"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-desc"
    }
  }, [_vm._v("희망상담내용")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.desc),
      expression: "application.desc"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "희망상담내용",
      "maxlength": "1000",
      "rows": "3",
      "title": "회망상담내용"
    },
    domProps: {
      "value": (_vm.application.desc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application, "desc", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-name"
    }
  }, [_vm._v("회원이름")]), _vm._v(" "), _c('p', {
    staticClass: "progress__only-text",
    attrs: {
      "id": "counsel-name"
    }
  }, [_vm._v(_vm._s(_vm.member.name))])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-org"
    }
  }, [_vm._v("상담기관")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.org),
      expression: "application.org"
    }],
    staticClass: "input__select",
    attrs: {
      "id": "counsel-org",
      "title": "counsel-org 선택"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.application, "org", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("기관 선택")]), _vm._v(" "), _vm._l((_vm.orgList), function(item) {
    return _c('option', {
      domProps: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "request-time"
    }
  }, [_vm._v("희망상담일시")]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10"
  }, [_c('div', {
    staticClass: "f-gutter-10__li grid-3"
  }, [_c('datepicker', {
    attrs: {
      "input-class": 'input__text',
      "language": "ko",
      "format": 'yyyy-MM-dd',
      "disabled": _vm.state.disabled,
      "placeholder": "희망일선택",
      "id": "request-time"
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.startTime),
      expression: "application.startTime"
    }],
    staticClass: "input__select",
    attrs: {
      "title": "희망시작시간"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.application, "startTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("희망시작시간")]), _vm._v(" "), _vm._l((24), function(n) {
    return _c('option', {
      domProps: {
        "value": _vm.getTimeValue(n, 'string')
      }
    }, [_vm._v(_vm._s(_vm.getTimeValue(n, 'time')))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.endTime),
      expression: "application.endTime"
    }],
    staticClass: "input__select",
    attrs: {
      "title": "희망종료시간"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.application, "endTime", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("희망종료시간")]), _vm._v(" "), _vm._l((24), function(n) {
    return _c('option', {
      domProps: {
        "value": _vm.getTimeValue(n + 1, 'string')
      }
    }, [_vm._v(_vm._s(_vm.getTimeValue(n + 1, 'time')))])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-worked"
    }
  }, [_vm._v("재직여부")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselWorkedWork"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.workType),
      expression: "application.workType"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselWorked",
      "id": "counselWorkedWork",
      "value": "재직",
      "title": "재직 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.workType, "재직")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "workType", "재직")
      }
    }
  }), _vm._v(" 재직\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselWorkedRetirement"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.workType),
      expression: "application.workType"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselWorked",
      "id": "counselWorkedRetirement",
      "value": "퇴직",
      "title": "퇴직 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.workType, "퇴직")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "workType", "퇴직")
      }
    }
  }), _vm._v(" 퇴직\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselWorkedNoWork"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.workType),
      expression: "application.workType"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselWorked",
      "id": "counselWorkedNoWork",
      "value": "재직해당사항없음",
      "title": "재직해당사항없음 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.workType, "재직해당사항없음")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "workType", "재직해당사항없음")
      }
    }
  }), _vm._v(" 재직해당사항없음  \n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselWorkedSelfEmp"
    }
  }, [_vm._v("\n        ("), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.workTypeEtc),
      expression: "application.workTypeEtc"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselWorkedetc",
      "id": "counselWorkedSelfEmp",
      "disabled": _vm.application.workType !== '재직해당사항없음',
      "value": "자영업",
      "title": "자영업 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.workTypeEtc, "자영업")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "workTypeEtc", "자영업")
      }
    }
  }), _vm._v(" 자영업\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselWorkedFreelancer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.workTypeEtc),
      expression: "application.workTypeEtc"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselWorkedetc",
      "id": "counselWorkedFreelancer",
      "disabled": _vm.application.workType !== '재직해당사항없음',
      "value": "프리랜서",
      "title": "프리랜서 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.workTypeEtc, "프리랜서")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "workTypeEtc", "프리랜서")
      }
    }
  }), _vm._v(" 프리랜서\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselWorkedHousewife"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.workTypeEtc),
      expression: "application.workTypeEtc"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselWorkedetc",
      "id": "counselWorkedHousewife",
      "disabled": _vm.application.workType !== '재직해당사항없음',
      "value": "전업주부",
      "title": "전업주부 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.workTypeEtc, "전업주부")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "workTypeEtc", "전업주부")
      }
    }
  }), _vm._v(" 전업주부\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselWorkedJobetc"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.workTypeEtc),
      expression: "application.workTypeEtc"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselWorkedetc",
      "id": "counselWorkedJobetc",
      "disabled": _vm.application.workType !== '재직해당사항없음',
      "value": "기타",
      "title": "기타 ) 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.workTypeEtc, "기타")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "workTypeEtc", "기타")
      }
    }
  }), _vm._v(" 기타 )\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-retireym"
    }
  }, [_vm._v("퇴직년월")]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10"
  }, [_c('div', {
    staticClass: "f-gutter-10__li grid-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.retireYear),
      expression: "application.retireYear"
    }],
    ref: "formationYear",
    staticClass: "form-control width-30 display-inline date-picker year",
    attrs: {
      "type": "number",
      "disabled": _vm.application.workType !== '퇴직',
      "placeholder": "YY(년, 숫자만 입력)",
      "title": "퇴직연도"
    },
    domProps: {
      "value": (_vm.application.retireYear)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application, "retireYear", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "f-gutter-10__li grid-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.retireMonth),
      expression: "application.retireMonth"
    }],
    ref: "formationMonth",
    staticClass: "form-control width-30 display-inline date-picker month",
    attrs: {
      "type": "number",
      "disabled": _vm.application.workType !== '퇴직',
      "placeholder": "MM(월, 숫자만 입력)",
      "title": "퇴직월"
    },
    domProps: {
      "value": (_vm.application.retireMonth)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application, "retireMonth", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-school"
    }
  }, [_vm._v("학력")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "isHighshcool"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.schoolClass),
      expression: "application.schoolClass"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselSchool",
      "id": "isHighshcool",
      "value": "고졸이하",
      "title": "고졸이하 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.schoolClass, "고졸이하")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "schoolClass", "고졸이하")
      }
    }
  }), _vm._v(" 고졸이하\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "isCollege"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.schoolClass),
      expression: "application.schoolClass"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselSchool",
      "id": "isCollege",
      "value": "전문대졸",
      "title": "전문대졸 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.schoolClass, "전문대졸")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "schoolClass", "전문대졸")
      }
    }
  }), _vm._v(" 전문대졸\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "isUniverity"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.schoolClass),
      expression: "application.schoolClass"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselSchool",
      "id": "isUniverity",
      "value": "대졸",
      "title": "대졸 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.schoolClass, "대졸")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "schoolClass", "대졸")
      }
    }
  }), _vm._v(" 대졸\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "isGraduate"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.schoolClass),
      expression: "application.schoolClass"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselSchool",
      "id": "isGraduate",
      "value": "대학원이상",
      "title": "대학원이상 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.schoolClass, "대학원이상")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "schoolClass", "대학원이상")
      }
    }
  }), _vm._v(" 대학원이상\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "isEtcSchool"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.schoolClass),
      expression: "application.schoolClass"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselSchool",
      "id": "isEtcSchool",
      "value": "기타",
      "title": "기타 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.schoolClass, "기타")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "schoolClass", "기타")
      }
    }
  }), _vm._v(" 기타\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupOfficer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupOfficer",
      "value": "공무원",
      "title": "공무원 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "공무원")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "공무원")
      }
    }
  }), _vm._v(" 공무원\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupTeacher"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupTeacher",
      "value": "교사",
      "title": "교사 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "교사")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "교사")
      }
    }
  }), _vm._v(" 교사\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupFine"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupFine",
      "value": "금융/보험",
      "title": "금융/보험 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "금융/보험")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "금융/보험")
      }
    }
  }), _vm._v(" 금융/보험\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupSales"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupSales",
      "value": "영업/판매",
      "title": "영업/판매 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "영업/판매")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "영업/판매")
      }
    }
  }), _vm._v(" 영업/판매\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupManage"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupManage",
      "value": "사무직",
      "title": "사무직 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "사무직")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "사무직")
      }
    }
  }), _vm._v(" 사무직\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupArt"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupArt",
      "value": "디자인/방송/예술",
      "title": "디자인/방송/예술 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "디자인/방송/예술")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "디자인/방송/예술")
      }
    }
  }), _vm._v(" 디자인/방송/예술\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupMedicne"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupMedicne",
      "value": "의료/보건",
      "title": "의료/보건 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "의료/보건")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "의료/보건")
      }
    }
  }), _vm._v(" 의료/보건\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupCare"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupCare",
      "value": "사회복지",
      "title": "사회복지 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "사회복지")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "사회복지")
      }
    }
  }), _vm._v(" 사회복지\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupConst"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupConst",
      "value": "건설/산업/생산",
      "title": "건설/산업/생산 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "건설/산업/생산")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "건설/산업/생산")
      }
    }
  }), _vm._v(" 건설/산업/생산\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupScien"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupScien",
      "value": "전문과학기술서비스",
      "title": "전문과학기술서비스 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "전문과학기술서비스")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "전문과학기술서비스")
      }
    }
  }), _vm._v(" 전문과학기술서비스\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupEdu"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupEdu",
      "value": "교육/연구",
      "title": "교육/연구 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "교육/연구")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "교육/연구")
      }
    }
  }), _vm._v(" 교육/연구\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselJobgroupHouse"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupHouse",
      "value": "전업주부",
      "title": "전업주부 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "전업주부")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "전업주부")
      }
    }
  }), _vm._v(" 전업주부\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking-2",
    attrs: {
      "for": "counselJobgroupEtc"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroup),
      expression: "application.jobgroup"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "jobgroup",
      "id": "counselJobgroupEtc",
      "value": "기타",
      "title": "기타 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.jobgroup, "기타")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "jobgroup", "기타")
      }
    }
  }), _vm._v(" 기타\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.jobgroupEtc),
      expression: "application.jobgroupEtc"
    }],
    attrs: {
      "type": "text",
      "placeholder": "기타",
      "disabled": _vm.application.jobgroup !== '기타',
      "name": "introContext",
      "class": "",
      "title": "기타"
    },
    domProps: {
      "value": (_vm.application.jobgroupEtc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application, "jobgroupEtc", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-house"
    }
  }, [_vm._v("가구")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselHouseAMan"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.houseType),
      expression: "application.houseType"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselHouse",
      "id": "counselHouseAMan",
      "value": "1인가구",
      "title": "1인가구 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.houseType, "1인가구")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "houseType", "1인가구")
      }
    }
  }), _vm._v(" 1인가구\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselHouseCouple"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.houseType),
      expression: "application.houseType"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselHouse",
      "id": "counselHouseCouple",
      "value": "부부중심가구",
      "title": "부부중심가구 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.houseType, "부부중심가구")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "houseType", "부부중심가구")
      }
    }
  }), _vm._v(" 부부중심가구\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselHouseFamily"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.houseType),
      expression: "application.houseType"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselHouse",
      "id": "counselHouseFamily",
      "value": "자녀(부모)동거",
      "title": "자녀(부모)동거 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.houseType, "자녀(부모)동거")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.application, "houseType", "자녀(부모)동거")
      }
    }
  }), _vm._v(" 자녀(부모)동거\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselHouseSingleparent"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.houseType),
      expression: "application.houseType"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselHouse",
      "id": "counselHouseSingleparent",
      "value": "한부모가구",
      "title": "한부모가구 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.houseType, "한부모가구")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "houseType", "한부모가구")
      }
    }
  }), _vm._v(" 한부모가구\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-care"
    }
  }, [_vm._v("해당사항")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselCareDisabledpersion"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.careType1),
      expression: "application.careType1"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "careType1",
      "id": "counselCareDisabledpersion",
      "value": "장애인",
      "title": "장애인 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.careType1, "장애인")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "careType1", "장애인")
      }
    }
  }), _vm._v(" 장애인\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselCareBasicPerson"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.careType1),
      expression: "application.careType1"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "careType1",
      "id": "counselCareBasicPerson",
      "value": "기초수급대상자",
      "title": "기초수급대상자 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.careType1, "기초수급대상자")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "careType1", "기초수급대상자")
      }
    }
  }), _vm._v(" 기초수급대상자\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselCareBasicPersonup"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.careType1),
      expression: "application.careType1"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "careType1",
      "id": "counselCareBasicPersonup",
      "value": "차상위",
      "title": "차상위 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.careType1, "차상위")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "careType1", "차상위")
      }
    }
  }), _vm._v(" 차상위\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselCareEtc"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.careType1),
      expression: "application.careType1"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "careType1",
      "id": "counselCareEtc",
      "value": "기타",
      "title": "기타 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.careType1, "기타")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "careType1", "기타")
      }
    }
  }), _vm._v(" 기타\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselCareNo"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.careType1),
      expression: "application.careType1"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "careType1",
      "id": "counselCareNo",
      "value": "해당사항없음",
      "title": "해당사항없음 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.careType1, "해당사항없음")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "careType1", "해당사항없음")
      }
    }
  }), _vm._v(" 해당사항없음\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-intro"
    }
  }, [_vm._v("신청경로(택1)")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselIntroFellow"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntroFellow",
      "value": "지인소개",
      "title": "지인소개 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "지인소개")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "지인소개")
      }
    }
  }), _vm._v(" 지인소개\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselIntroInternet"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntroInternet",
      "value": "인터넷",
      "title": "인터넷 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "인터넷")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "인터넷")
      }
    }
  }), _vm._v(" 인터넷\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselIntroSns"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntroSns",
      "value": "SNS",
      "title": "SNS 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "SNS")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "SNS")
      }
    }
  }), _vm._v(" SNS\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselIntroPrbooks"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntroPrbooks",
      "value": "홍보책자",
      "title": "홍보책자 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "홍보책자")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "홍보책자")
      }
    }
  }), _vm._v(" 홍보책자\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselIntroRadio"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntroRadio",
      "value": "라디오/팟캐스트",
      "title": "라디오/팟캐스트 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "라디오/팟캐스트")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "라디오/팟캐스트")
      }
    }
  }), _vm._v(" 라디오/팟캐스트\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselIntroOutdoor"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntroOutdoor",
      "value": "옥외광고",
      "title": "옥외광고 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "옥외광고")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "옥외광고")
      }
    }
  }), _vm._v(" 옥외광고\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselIntroOrgintro"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntroOrgintro",
      "value": "타기관 안내",
      "title": "타기관 안내 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "타기관 안내")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "타기관 안내")
      }
    }
  }), _vm._v(" 타기관 안내\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselIntro50plus"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntro50plus",
      "value": "50+재단/캠퍼스/센터",
      "title": "50+재단/캠퍼스/센터 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "50+재단/캠퍼스/센터")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "50+재단/캠퍼스/센터")
      }
    }
  }), _vm._v(" 50+재단/캠퍼스/센터\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselIntroTv"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntroTv",
      "value": "TV",
      "title": "TV 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "TV")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "TV")
      }
    }
  }), _vm._v(" TV\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselIntroPaper"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntroPaper",
      "value": "신문",
      "title": "신문 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "신문")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "신문")
      }
    }
  }), _vm._v(" 신문\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking-2",
    attrs: {
      "for": "counselIntroEtcEtc"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pathIntro),
      expression: "application.pathIntro"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "counselIntro",
      "id": "counselIntroEtcEtc",
      "value": "기타",
      "title": "기타 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.pathIntro, "기타")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "pathIntro", "기타")
      }
    }
  }), _vm._v(" 기타\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.pahtIntroEtc),
      expression: "application.pahtIntroEtc"
    }],
    attrs: {
      "type": "text",
      "placeholder": "기타",
      "disabled": _vm.application.pathIntro !== '기타',
      "name": "introContext",
      "class": "",
      "title": "기타"
    },
    domProps: {
      "value": (_vm.application.pahtIntroEtc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application, "pahtIntroEtc", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselVisitFirst"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.extType1),
      expression: "application.extType1"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "checkbox",
      "id": "counselVisitFirst",
      "value": "처음방문",
      "title": "처음방문 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.application.extType1) ? _vm._i(_vm.application.extType1, "처음방문") > -1 : (_vm.application.extType1)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.application.extType1,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "처음방문",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.application, "extType1", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.application, "extType1", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.application, "extType1", $$c)
        }
      }
    }
  }), _vm._v(" 처음방문\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselVisitExprience"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.extType2),
      expression: "application.extType2"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "checkbox",
      "id": "counselVisitExprience",
      "value": "상담경험",
      "title": "상담경험 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.application.extType2) ? _vm._i(_vm.application.extType2, "상담경험") > -1 : (_vm.application.extType2)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.application.extType2,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "상담경험",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.application, "extType2", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.application, "extType2", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.application, "extType2", $$c)
        }
      }
    }
  }), _vm._v(" 상담경험\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselVisitCommunity"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.extType3),
      expression: "application.extType3"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "checkbox",
      "id": "counselVisitCommunity",
      "value": "커뮤니티활동",
      "title": "커뮤니티활동 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.application.extType3) ? _vm._i(_vm.application.extType3, "커뮤니티활동") > -1 : (_vm.application.extType3)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.application.extType3,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "커뮤니티활동",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.application, "extType3", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.application, "extType3", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.application, "extType3", $$c)
        }
      }
    }
  }), _vm._v(" 커뮤니티활동\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselVisitProgram"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.extType4),
      expression: "application.extType4"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "checkbox",
      "id": "counselVisitProgram",
      "value": "교육프로그램참여",
      "title": "교육프로그램참여 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.application.extType4) ? _vm._i(_vm.application.extType4, "교육프로그램참여") > -1 : (_vm.application.extType4)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.application.extType4,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "교육프로그램참여",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.application, "extType4", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.application, "extType4", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.application, "extType4", $$c)
        }
      }
    }
  }), _vm._v(" 교육프로그램참여\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselVisitContest"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.extType5),
      expression: "application.extType5"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "checkbox",
      "id": "counselVisitContest",
      "value": "공모사업참여",
      "title": "공모사업참여 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.application.extType5) ? _vm._i(_vm.application.extType5, "공모사업참여") > -1 : (_vm.application.extType5)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.application.extType5,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "공모사업참여",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.application, "extType5", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.application, "extType5", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.application, "extType5", $$c)
        }
      }
    }
  }), _vm._v(" 공모사업참여\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking",
    attrs: {
      "for": "counselVisitForum"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.extType6),
      expression: "application.extType6"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "checkbox",
      "id": "counselVisitForum",
      "value": "포럼/축제등 행사참여",
      "title": "포럼/축제등 행사참여 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.application.extType6) ? _vm._i(_vm.application.extType6, "포럼/축제등 행사참여") > -1 : (_vm.application.extType6)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.application.extType6,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "포럼/축제등 행사참여",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.application, "extType6", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.application, "extType6", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.application, "extType6", $$c)
        }
      }
    }
  }), _vm._v(" 포럼/축제등 행사참여\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-checking-2",
    attrs: {
      "for": "counselVisitEtcVisit"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.extType7),
      expression: "application.extType7"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "checkbox",
      "id": "counselVisitEtcVisit",
      "value": "기타",
      "title": "기타 선택"
    },
    domProps: {
      "checked": Array.isArray(_vm.application.extType7) ? _vm._i(_vm.application.extType7, "기타") > -1 : (_vm.application.extType7)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.application.extType7,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "기타",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.application, "extType7", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.application, "extType7", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.application, "extType7", $$c)
        }
      }
    }
  }), _vm._v(" 기타\n        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.expTypeEtc),
      expression: "application.expTypeEtc"
    }],
    attrs: {
      "type": "text",
      "placeholder": "기타",
      "class": "",
      "title": "기타"
    },
    domProps: {
      "value": (_vm.application.expTypeEtc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application, "expTypeEtc", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.application.carRer),
      expression: "application.carRer",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "input__textarea",
    attrs: {
      "id": "counsel-career",
      "title": "counsel-career 입력"
    },
    domProps: {
      "value": (_vm.application.carRer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.application, "carRer", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_vm._m(4), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-check-lebel",
    attrs: {
      "for": "rule"
    }
  }, [_vm._v("\n               본인은 위 내용을 확인하였으며, 모든 내용에    \n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-check-lebel",
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": "agree"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.agree),
      expression: "application.agree"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "agree",
      "id": "agree",
      "value": "true",
      "title": "동의함 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.agree, "true")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "agree", "true")
      }
    }
  }), _vm._v("동의 합니다.\n      ")]), _vm._v("\n                    \n      "), _c('label', {
    staticClass: "sorting-box-check-lebel",
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": "disagree"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.application.agree),
      expression: "application.agree"
    }],
    staticClass: "sorting-box-check-input",
    attrs: {
      "type": "radio",
      "name": "agree",
      "id": "disagree",
      "value": "false",
      "title": "동의하지 않음 선택"
    },
    domProps: {
      "checked": _vm._q(_vm.application.agree, "false")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.application, "agree", "false")
      }
    }
  }), _vm._v("동의하지 않습니다.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "sorting-box-check-lebel",
    attrs: {
      "for": "registeryear"
    }
  }, [_vm._v("  \n        " + _vm._s(new Date().getFullYear()) + "년\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-check-lebel",
    attrs: {
      "for": "registermonth"
    }
  }, [_vm._v("  \n        " + _vm._s(new Date().getMonth() + 1) + "월\n      ")]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-check-lebel",
    attrs: {
      "for": "registerdate"
    }
  }, [_vm._v("  \n        " + _vm._s(new Date().getDate()) + "일\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-submit-gruop"
  }, [_c('button', {
    staticClass: "form-submit__btn btn--blue-line",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("상담신청")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-jobgroup"
    }
  }, [_vm._v("희망직업군"), _c('br'), _vm._v("(재직자 포함,택1)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-visit"
    }
  }, [_vm._v("이용경험"), _c('br'), _vm._v("(중복가능)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "inline-input__label",
    attrs: {
      "for": "counsel-career"
    }
  }, [_vm._v("주요경력및"), _c('br'), _vm._v(" 자격사항")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-input-group clearfix"
  }, [_c('label', {
    staticClass: "sorting-box-check-lebel",
    attrs: {
      "for": "rule"
    }
  }, [_vm._v("  \n        ■ 개인정보 수집 ∙ 활동 동의\n\t\t상담 신청자를 대상으로 아래와 같이 개인정보를 수집하고자 합니다."), _c('br'), _vm._v("\n\t\t※ 개인정보 수집ㆍ활용  목적 : 50+상담 프로그램 관련 서비스 제공 및 사업관리"), _c('br'), _vm._v("\n\t\t※ 수집ㆍ활용 개인정보 항목 : 이름, 성별, 생년월일, 휴대전화번호, 이메일 주소"), _c('br'), _vm._v("\n\t\t※ 개인정보 보유 및 이용기간 : 개인정보 수집ㆍ활용에 대해 동의한 날로부터 5년 이내"), _c('br')]), _vm._v(" "), _c('label', {
    staticClass: "sorting-box-check-lebel",
    attrs: {
      "for": "rule"
    }
  }, [_vm._v("  \n        ■ 상담정보 수집 ∙ 활동 동의\n                상담 신청자를 대상으로 아래와 같이 개인정보를 수집하고자 합니다."), _c('br'), _vm._v("\n                     ※ 상담 시 수집한 일부 정보는 더 나은 품질의 상담 서비스 제공을 위해 서울시 \n          50플러스재단 내 관계업무 담당자에게 공유되어 분석용ㆍ연구용 데이터로 활용될 수 있습니다."), _c('br'), _vm._v("\n                     ※ 상담정보 항목에서는 개인정보 및 상담내용, 비밀항목 등은 제외됩니다.\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "sorting-box-check-lebel",
    attrs: {
      "for": "rule"
    }
  }, [_vm._v("  \n                     ※ 귀하는 위와 같은 개인정보 및 상담 데이터 수집ㆍ활용에 동의하지 않으실 수 있으며, 이 경우 50+상담 진행은 불가합니다. "), _c('br')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3b5bdf8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/main/counsel/CounselForm.vue
// module id = 1504
// module chunks = 6